import Component from './message_convert.vue'
export default Component
